import { Stack } from '@ovotech/element-v5';
import { Notification } from '@ovotech/nebula';
import React, { ComponentProps } from 'react';
import { CodeBox } from '../../CodeBox';
import { TopupActions } from '../../TopupActions';
import { TopupCopy } from '../../utils/topupCopy';
import { StyledHeading, StyledParagraph } from './styles';

type Props = ComponentProps<typeof Notification> & {
  copy: TopupCopy;
  code?: ComponentProps<typeof CodeBox> | null;
};

export const NotificationCard = ({ copy, code, ...notification }: Props) => (
  <Notification {...notification} dismissable={!!notification.onDismiss}>
    <Stack spaceBetween={3}>
      {copy.title && <StyledHeading>{copy.title}</StyledHeading>}
      {copy.message && <StyledParagraph>{copy.message}</StyledParagraph>}
      {code && <CodeBox {...code} />}
      {copy.nextStep && <StyledParagraph>{copy.nextStep}</StyledParagraph>}
      <TopupActions actions={copy.buttons} />
    </Stack>
  </Notification>
);
